import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* globals window */
import fetch from 'isomorphic-fetch';
export function fetchApi(request) {
  return new Promise(function ($return, $error) {
    var _request$method = request.method,
        method = _request$method === void 0 ? 'POST' : _request$method,
        url = request.url,
        body = request.body,
        _request$catchErrors = request.catchErrors,
        catchErrors = _request$catchErrors === void 0 ? false : _request$catchErrors,
        _request$httpResponse = request.httpResponseErrors,
        httpResponseErrors = _request$httpResponse === void 0 ? false : _request$httpResponse,
        rest = _objectWithoutProperties(request, ["method", "url", "body", "catchErrors", "httpResponseErrors"]);

    var promise = fetch(url, _objectSpread({}, rest, {
      credentials: 'include',
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Request-Source': 'ajax',
        gbcsrf: typeof window !== 'undefined' ? window.gbcsrf : undefined
      },
      body: body ? JSON.stringify(body) : undefined
    })).then(function (response) {
      return new Promise(function ($return, $error) {
        var headers, status, responseBody, contentType, _responseBody;

        headers = response.headers, status = response.status;
        contentType = response.headers.get('content-type').toLowerCase();

        if (contentType && contentType.includes('application/json')) {
          return Promise.resolve(response.json()).then(function ($await_2) {
            try {
              responseBody = $await_2;
              return $If_1.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        } else {
          return Promise.resolve(response.blob()).then(function ($await_3) {
            try {
              responseBody = $await_3;
              return $If_1.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }

        function $If_1() {
          if (httpResponseErrors && (status < 200 || status > 299)) {
            return $return({
              error: new Error(((_responseBody = responseBody) === null || _responseBody === void 0 ? void 0 : _responseBody.message) || status),
              body: responseBody,
              status: status,
              headers: headers,
              request: request
            });
          }

          return $return({
            request: request,
            status: status,
            headers: headers,
            body: responseBody
          });
        }
      });
    });

    if (catchErrors) {
      return $return(promise.catch(function (error) {
        return {
          error: error,
          request: request
        };
      }));
    }

    return $return(promise);
  });
}